<template>
  <div>
    <div v-if="!isDay">
      <div
        class="day-view-selector"
        :class="isMobile && 'parent-day-grid pl-2'"
      >
        <div
          v-for="day in days"
          :key="day.name"
          class="day-div col font-weight-bold "
          :class="{
            'px-3': isMobile,
            'bg-orange text-white': selected,
            'bg-secondary-3': !selected,
            'disabled-day': day.id == 0 || day.id == 6,
          }"
          @click="onSelectDay"
        >
          <span>
            {{ isMobile ? day.name.slice(0, 2) : day.name }}
          </span>
        </div>
      </div>
      <div
        class="pt-2 day-view-selector"
        :class="isMobile && 'parent-day-grid pl-2 mb-3'"
      >
        <div
          v-for="day in days"
          :key="day.number"
          :class="[
            'col',
            'day-div',
            'day-number',
            'rounded',
            'font-weight-bold',
            color,
          ]"
          @click="onSelectDay"
        >
          <span>
            {{ day.dayNumber }}
          </span>
        </div>
      </div>
    </div>

    <section v-if="isDay" class="onlyday">
      <div
        class="day-div col font-weight-bold mb-2"
        :class="{
          'px-3': isMobile,
          'bg-orange text-white': selected,
          'bg-secondary-3': !selected,
          'disabled-day': isWeekend,
        }"
      >
        <span>
          {{ seeWeekDay() }}
        </span>
      </div>
      <div
        :class="[
          'col',
          'day-div',
          'day-number',
          'rounded',
          'font-weight-bold',
          color,
        ]"
      >
        <span>
          {{ seeNumberDay() }}
        </span>
      </div>
    </section>
  </div>
</template>

<script>
import calendarViewModes from '@/utils/shared/constants/calendarViewModes';
import moment from 'moment';

export default {
  name: 'VisitCalendarDay',
  props: {
    days: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Boolean,
      default: () => false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: () => calendarViewModes.Week,
    },
    dates: {
      type: Object,
      default: null,
    },
  },
  computed: {
    color() {
      return this.selected ? 'bg-orange text-white' : 'bg-secondary-3';
    },
    isDay() {
      return this.value === calendarViewModes.Day;
    },
    isWeekend() {
      return (
        this.days[5].id === this.getWeekDay() ||
        this.days[6].id === this.getWeekDay()
      );
    },
  },
  methods: {
    onSelectDay() {
      const value = this.selected ? null : this.day;
      this.$emit('select', value);
    },
    seeWeekDay() {
      var locale = moment(this.dates.startDate).locale('es-us');
      var dateStr = locale.format('dddd');
      dateStr = dateStr[0].toUpperCase() + dateStr.substring(1);
      return dateStr;
    },
    seeNumberDay() {
      var locale = moment(this.dates.startDate).locale('es-us');
      var dateStr = locale.format('D');
      dateStr = dateStr[0].toUpperCase() + dateStr.substring(1);
      return dateStr;
    },
    getWeekDay() {
      var numberWeek = moment(this.dates.startDate).day();
      return numberWeek;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.day-view-selector {
  display: flex;
}
.day-div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  background-color: map-get($colors, 'gray-1');
  margin-right: 4px;
  border-radius: 4px;
  cursor: pointer;
  span {
    user-select: none;
  }
}

.availability-calendar-day-main > div {
  cursor: pointer;
  color: #435357;
}
.bg-orange {
  background-color: map-get($colors, 'orange');
}
.day-number {
  background-color: #d9e5df !important;
}
.disabled-day {
  background-color: #e2e2e2 !important;
}

.parent-day-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 5px;
  grid-row-gap: 0px;
}

.onlyday div {
  border-radius: 4px;
}
.onlyday div span {
  position: absolute;
  left: 5%;
}
</style>
